// Analytics.jsx

import React from "react";

import {
  Card,
  Row,
  Col,
  Statistic,
} from "antd";

import {
  RiseOutlined,
  TeamOutlined,
  DollarOutlined,
  BookOutlined,
} from "@ant-design/icons";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const Analytics = ({ theme }) => {
  const data = [
    { year: "2022", students: 1200 },
    { year: "2023", students: 1800 },
    { year: "2024", students: 2450 },
  ];

  const cardStyle = {
    background: theme.card,
    border: `1px solid ${theme.border}`,
    borderRadius: 14,
  };

  const statistics = [
    {
      title: "Growth",
      value: "25%",
      icon: <RiseOutlined />,
    },
    {
      title: "Students",
      value: "2450",
      icon: <TeamOutlined />,
    },
    {
      title: "Income",
      value: "$85K",
      icon: <DollarOutlined />,
    },
    {
      title: "Courses",
      value: "120",
      icon: <BookOutlined />,
    },
  ];

  return (
    <div>
      <Row gutter={[12, 12]}>
        {statistics.map((item, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <Card
              style={cardStyle}
              bodyStyle={{
                padding: 12,
              }}
            >
              <Statistic
                title={item.title}
                value={item.value}
                prefix={item.icon}
                valueStyle={{
                  color: theme.text,
                  fontSize: 24,
                }}
              />
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        title="Enrollment Growth"
        style={{
          ...cardStyle,
          marginTop: 12,
        }}
        bodyStyle={{
          padding: 12,
        }}
      >
        <ResponsiveContainer
          width="100%"
          height={240}
        >
          <BarChart data={data}>
            <XAxis dataKey="year" />
            <YAxis />
            <Tooltip />

            <Bar
              dataKey="students"
              fill="#2563EB"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </Card>
    </div>
  );
};

export default Analytics;